export const createObjectiveDropdownValues = [
  {
    label: 'None',
    value: 'NONE',
    valuesToSelect: [],
  },
  {
    label: 'Company',
    value: 'CREATE_OBJECTIVE_COMPANY',
    valuesToSelect: [
      'CREATE_OBJECTIVE_INDIVIDUAL',
      'CREATE_OBJECTIVE_TEAM',
      'CREATE_OBJECTIVE_DEPARTMENT',
      'CREATE_OBJECTIVE_COMPANY',
    ],
  },
  {
    label: 'Department',
    value: 'CREATE_OBJECTIVE_DEPARTMENT',
    valuesToSelect: ['CREATE_OBJECTIVE_INDIVIDUAL', 'CREATE_OBJECTIVE_TEAM', 'CREATE_OBJECTIVE_DEPARTMENT'],
  },
  {
    label: 'Team',
    value: 'CREATE_OBJECTIVE_TEAM',
    valuesToSelect: ['CREATE_OBJECTIVE_INDIVIDUAL', 'CREATE_OBJECTIVE_TEAM'],
  },
  {
    label: 'Individual',
    value: 'CREATE_OBJECTIVE_INDIVIDUAL',
    valuesToSelect: ['CREATE_OBJECTIVE_INDIVIDUAL'],
  },
];

export const createKeyResultDropdownValues = [
  {
    label: 'None',
    value: 'NONE',
    description: 'The user cannot create key results',
  },
  {
    label: 'Parent Mandatory',
    value: 'CREATE_KEY_RESULT_PARENT_MANDATORY',
    description: 'The user can only create key results that are aligned to a parent goal',
  },
  {
    label: 'Parent Non-Mandatory',
    value: 'CREATE_KEY_RESULT_PARENT_NON_MANDATORY',
    description: 'The user can create key results that may or may not be aligned to parent goal',
  },
];
